module.exports = __webpack_public_path__ + "static/media/flow_bank.7e960c0c.svg";